import React from 'react';
import '../css/HomePage.css';
import '../css/AboutUs.css';
import Navigationbar from './NavigationBar';
import Footer from './Footer';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa'; // Icons for LinkedIn and email

const AboutUs = () => {
    // Example team members data
    const teamMembers = [
        { name: 'Mohammed Omer Ahmed', email: 'mxo1193@mavs.uta.edu', linkedin: 'https://linkedin.com/in/member1' },
        { name: 'Kondeti, Varshitha', email: 'vxk8366@mavs.uta.edu', linkedin: 'https://linkedin.com/in/member2' },
        { name: 'Mohammed, Ali Rayyan', email: 'axm9415@mavs.uta.edu', linkedin: 'https://linkedin.com/in/member3' },
        { name: 'Katasani, Sai Ganesh Reddy', email: 'sxk7730@mavs.uta.edu', linkedin: 'https://linkedin.com/in/member4' },
        { name: 'More, Utkarsh Rajesh', email: 'uxm5803@mavs.uta.edu', linkedin: 'https://linkedin.com/in/member5' }
    ];

    return (
        <div>
            <Navigationbar />
            <div className='HomePageContent'>
                <h1 className='HomePageHeaders'>About Us</h1>
                <p>
                    Jumpstart your fitness journey with Fitness Tracker, the all-in-one platform designed to empower you to reach your health and wellness goals. Whether you're looking to track your daily activities, monitor your nutritional intake, or set and achieve specific fitness milestones, Fitness Tracker provides the tools you need for success.
                </p>
                <div className='HomePageAd'>
                    <video controls autoPlay loop muted>
                        <source src="/images/HomePageAd.mp4" type="video/mp4" />
                    </video>
                </div>
                <br></br>
                <br></br>
                <div className='HomePageFeatures'>
                    <h1 className='headers'>Team Members</h1>
                    <div className='team-members'>
                        {teamMembers.map((member, index) => (
                            <div key={index} className='team-member'>
                                <h3 className='headers'>{member.name}</h3>
                                <p><FaEnvelope /> <a href={`mailto:${member.email}`}>{member.email}</a></p>
                                <p><FaLinkedin /> <a href={member.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a></p>
                            </div>
                        ))}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default AboutUs;
